<script setup>
import { useRoute } from '@js/utils/route';
import { ref } from 'vue';

const { googleAdsKeywordManagement, tenant, callback } = defineProps({
    googleAdsKeywordManagement: {
        type: Object,
        required: true,
    },
    tenant: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

const loading = ref(false);

function action() {
    loading.value = true;

    axios
        .post(
            route('front.projectManagement.sea.postGenerateKeywordManagement', {
                tenant: tenant.id,
                googleAdsKeywordManagement: googleAdsKeywordManagement.id,
            }),
        )
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .finally(() => {
            loading.value = false;
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="action" :loading="loading" />
</template>
